module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('canvas', {
    staticStyle: {
      "width": "100%",
      "display": "block"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "annotationLayer"
  }), _vm._v(" "), _c('resize-sensor', {
    on: {
      "resize": _vm.resize
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d60af4f","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iexplore/components/pdf/src/Pdf.vue
// module id = 1225
// module chunks = 2